import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import VnButton from '@ui/components/VnButton';
import { addOutline } from 'ionicons/icons';
import ModalPopup from '@ui/components/VnModal';
import AddRolePermissionForm from './AddRolePermissionForm';
import RoleTable from './RoleTable';
import UpdateRolePermissionForm from './UpdateRolePermissionForm';
import { getAllUserRolesAsync, updateRoleStatusAsync } from '@application/features/auth/authThunks';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import VnNotificationModel from '@ui/components/VnNotificationModel';
const RolePermissionsTab = () => {
    const dispatch = useAppDispatch();
    const [selectedRoleId, setSelectedRoleId] = useState(0);
    const [isAddRoleOpen, setIsAddRoleOpen] = useState(false);
    const [isUpdateRoleOpen, setIsUpdateRoleOpen] = useState(false);
    const [confirmMessageForRoleStatusChange, setConfirmMessageForRoleStatusChange] = useState('');
    const [isOpenRoleStatusChangePopup, setIsOpenRoleStatusChangePopup] = useState(false);
    const [selectedRoleStatus, setSelectedRoleStatus] = useState({ roleId: 0, isActive: false });
    const { roles } = useAppSelector((state) => state.auth);
    const onAddRoleCloseClicked = () => {
        dispatch(getAllUserRolesAsync());
        setIsAddRoleOpen(false);
    };
    const onAddRoleClick = () => {
        setIsAddRoleOpen(true);
    };
    const onRoleRowClick = (roleId) => {
        setSelectedRoleId(roleId);
        setIsUpdateRoleOpen(true);
    };
    const onUpdateRoleCloseClicked = () => {
        dispatch(getAllUserRolesAsync());
        setIsUpdateRoleOpen(false);
    };
    useEffect(() => {
        dispatch(getAllUserRolesAsync());
    }, []);
    const onRoleStatusChange = (id, checked) => {
        setSelectedRoleStatus({ roleId: id, isActive: checked });
        if (checked) {
            setConfirmMessageForRoleStatusChange('Bent u zeker dat u deze rol wilt inschakelen?');
        }
        else {
            setConfirmMessageForRoleStatusChange('Weet je zeker dat je deze rol wilt uitzetten?<br/> Dit blokkeert alle gebruikers met deze rol.');
        }
        setIsOpenRoleStatusChangePopup(true);
    };
    const onRoleStatusChangeCancel = () => {
        setIsOpenRoleStatusChangePopup(false);
        setSelectedRoleStatus({ roleId: 0, isActive: false });
    };
    const onRoleStatusChangeConfirm = () => {
        dispatch(updateRoleStatusAsync(selectedRoleStatus))
            .unwrap()
            .then((res) => {
            dispatch(getAllUserRolesAsync());
            setIsOpenRoleStatusChangePopup(false);
            setSelectedRoleStatus({ roleId: 0, isActive: false });
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { children: _jsx(Form, { children: _jsx("div", { style: {
                            display: 'flex',
                            justifyContent: 'end',
                            alignItems: 'center',
                            marginRight: 'auto',
                            marginLeft: '0rem',
                            marginTop: '2rem',
                            marginBottom: '2rem'
                        }, children: _jsx("div", { children: _jsx(VnButton, { icon: addOutline, customClassName: 'Vn-save-button', mode: 'primary', size: 'lg', text: 'Nieuwe Rol', onClick: onAddRoleClick, type: 'button' }) }) }) }) }), _jsx("div", { children: _jsx(RoleTable, { onRowClick: onRoleRowClick, onRoleStatusChange: onRoleStatusChange, roles: roles ?? [] }) }), _jsx(ModalPopup, { title: 'Nieuwe Rol', content: _jsx(AddRolePermissionForm, { onClose: () => onAddRoleCloseClicked() }), onOpen: isAddRoleOpen, onClose: () => onAddRoleCloseClicked(), modalWidth: 'lg' }), _jsx(ModalPopup, { title: 'rol updaten', content: _jsx(UpdateRolePermissionForm, { onClose: () => onUpdateRoleCloseClicked(), roleId: selectedRoleId }), onOpen: isUpdateRoleOpen, onClose: () => onUpdateRoleCloseClicked(), modalWidth: 'lg' }), _jsx(VnNotificationModel, { message: confirmMessageForRoleStatusChange, onCancel: onRoleStatusChangeCancel, onConfirm: onRoleStatusChangeConfirm, onOpen: isOpenRoleStatusChangePopup, onCancelShow: true })] }));
};
export default RolePermissionsTab;
